import { BasementQuestionType } from '../protos/backendproto/QuestionService_pb';
import { SaveBasementQuestionsRequest } from '../protos/adminbackendproto/AdminQuestionService_pb';
import QuestionsWorkspace, { GroupAdapter } from './QuestionsWorkspace';

const basementAdapter: GroupAdapter<BasementQuestionType> = {
    title: "Basement questions",
    noun: "area",
    groups: (response) => response.getBasementQuestionsList(),
    name: (area) => area.getName(),
    setName: (area, name) => { area.setName(name) },
    create: () => new BasementQuestionType(),
    save: (client, areas) => client.saveBasementQuestions(
        new SaveBasementQuestionsRequest().setQuestionsPerAreaList(areas), {}),
};

export default function BasementQuestionsPage() {
    return <QuestionsWorkspace adapter={basementAdapter} />
}
